import { Box } from '@material-ui/core';
import React from 'react'
// import ItemsTableTogglerRequestBibButton from '../../ItemsTable/ItemsTableToggler/ItemsTableTogglerRequestBibButton/ItemsTableTogglerRequestBibButton';
import ArrowDropDownSharpIcon from '@material-ui/icons/ArrowDropDownSharp';
import ArrowDropUpSharpIcon from '@material-ui/icons/ArrowDropUpSharp';
import styles from '../../../../HoldingsTable/HoldingsTable.module.scss';

const ConnectedRecordsToggler = ({ showTable, setShowTable, name = "" }) => {
const toggleTableHandler = () => {
  setShowTable(!showTable);
};

return (
  <Box className={showTable ? styles.openTable : styles.closeTable}>
    <div
      className={[styles.relatedRecordHeader, showTable ? styles.open : styles.close].join(
        ' '
      )}
    >
      <span className={styles.headerLabel}>
        {name || 'Kapcsolódó rekord'}
      </span>
      {/* <span className={styles.headerValue}>( {count ?? <CircularProgress color={"inherit"} size={15}/>} )</span> */}
      <span>
        {/* <ItemsTableTogglerRequestBibButton
          bibData={bibData}
          me={me}
          setRequestData={setRequestData}
        /> */}
      </span>
      <span className={styles.headerStatusIcon}>
        {showTable ? (
          <ArrowDropUpSharpIcon onClick={toggleTableHandler} />
        ) : (
          <ArrowDropDownSharpIcon onClick={toggleTableHandler} />
        )}
      </span>
    </div>
  </Box>
  )
}

export default ConnectedRecordsToggler